import styled from "styled-components";

const Btncontainer = styled.div`
  .csvLinkHide {
    display: none;
  }
`;

export { Btncontainer };
